<template>
  <div class="page">
    <section style="position: fixed; left:0; top:0;z-index:99;width: 100%;">
      <div class="navbar">
        <div class="back" @click="$router.push('/')"></div>
        <div class="search">
          <input type="text" v-model="keyword" placeholder="搜索历史订单" />
        </div>
        <div class="searchBtn" @click="search">搜索</div>
      </div>
      <div class="filter">
        <p :class="active == item.status ? 'active' : ''" v-for="(item,index) in status" :key="index" @click="changeStatus(item,index)">{{item.title}}</p>
      </div>
    </section>
    <section style="padding-top: 0.92rem;">
      <van-pull-refresh v-if="list.length != 0" v-model="refreshing" @refresh="onRefresh">
        <van-list class="orderList van-clearfix" v-model="loading" :finished="finished" finished-text="已经到底线了" @load="loadmore" :immediate-check="false">
          <div class="orderList-item" v-for="(item,index) in list" :key="index">
            <div class="head">
              <span class="time">{{item.create_time}}</span>
              <section v-if="item.status == 0 && item.status_pay == 0" style="display:flex; align-items:center">
                <van-button type="warning" size="mini" @click="delete_ship(item)" style="margin-right: 0.1rem;">删除订单</van-button>
                <span>待支付</span>
              </section>

              <span v-if="item.status_pay == 1 && item.status_ship == 0">待发货</span>
              <span v-if="item.status_pay == 1 && item.status_ship == 1 && item.status == 0">已发货</span>
              <span v-if="item.status_pay == 2">退款完成</span>
              <span v-if="item.status == 1 && item.status_pay == 1 && item.status_ship == 1 && item.status_refund == 0">已完成</span>
              <span v-if="item.status == 1 && item.status_pay == 1 && item.status_ship == 1 && item.status_refund == 1">售后中</span>
              <span v-if="item.status == 1 && item.status_pay == 1 && item.status_ship == 1 && item.status_refund == 2">售后完成</span>
            </div>
            <div class="det">
              <div class="pic">
                <img :src="item.goodsimg" />
              </div>
              <div class="det-info">
                <h4>{{item.goodsname}}</h4>
                <p>{{item.param}}</p>
                <section>
                  <span>实付款<strong>￥{{item.money_pay}}</strong></span>
                  <span>数量：{{item.buy_num}}</span>
                </section>
              </div>
            </div>
            <div class="options">
              <p class="more">订单编号：{{item.order_sn}}</p>
              <!-- <van-popover placement="top-start" v-model="item.showPopover" trigger="click" :actions="actions" @select="onSelect" @open="onOpen(item,index)">
              <template #reference>
                <span class="more">更多</span>
              </template>
            </van-popover> -->
              <div class="button" v-if="item.status == 0 && item.status_pay == 0" style="background:#2196f3;" @click="submit(item)">去付款</div>
              <div class="button" v-if="item.status_pay == 1 && item.status_ship == 0" style="background:#D51012;" @click="apply_refund(item)">申请退款</div>
              <div class="button" v-if="item.status_pay == 1 && item.status_ship == 1 && item.status == 0" style="background:#4caf50" @click="openReceive(item)">确认收货</div>
              <div class="button" v-if="item.status == 1 && item.status_pay == 1 && item.status_ship == 1 && item.status_refund == 0" @click="openRefund(item)">发起售后</div>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
      <template v-if="list.length == 0">
        <van-empty description="暂无数据" />
      </template>
    </section>

    <!-- 退款温馨提示 -->
    <van-overlay :show="tips_tk" z-index="99">
      <div class="dialog" v-show="tips_tk">
        <h3 class="dialog-title">温馨提示</h3>
        <p>发货后就不能申请退款了哦 </p>
        <div class="dialog-button" @click="tips_tk = false">确定</div>
      </div>
    </van-overlay>

    <!-- 确认收货提示 -->
    <van-overlay :show="tips_receive" z-index="99">
      <div class="dialog" v-show="tips_receive">
        <h3 class="dialog-title">确认提示</h3>
        <p>确定收到货了吗? <br />收货后商家为您开具发票 </p>
        <section class="dialog-btn">
          <div class="btn_cancel" @click="tips_receive = false">取消</div>
          <div class="btn_right" @click="receive">确定</div>
        </section>
      </div>
    </van-overlay>

    <!-- 售后表单 -->
    <van-overlay :show="tips_refund" z-index="99">
      <div class="dialog" style="width: 90%;" v-show="tips_refund">
        <h3 class="dialog-title">售后信息填写</h3>
        <div class="dialog-form">
          <van-field v-model="desc" label-width="80" rows="1" autosize label="售后描述" type="textarea" placeholder="请输入描述" />
          <van-field name="uploader" label-width="80" label="图片上传">
            <template #input>
              <van-uploader v-model="fileList" :after-read="afterRead" @delete="deleteFile" :max-count="1" />
            </template>
          </van-field>
        </div>
        <section class="dialog-btn">
          <div class="btn_cancel" @click="hideRefund">取消</div>
          <div class="btn_right" @click="refund">确定</div>
        </section>
      </div>
    </van-overlay>

    <!-- <van-action-sheet v-model="show" :actions="!weixinFlag ? actions1 : actions2" cancel-text="取消" close-on-click-action @select="submit" /> -->
  </div>
</template>
<script>
import PayMixins from "../mixins/paymixins"
import { Dialog } from 'vant';
export default {
  components: {
    [Dialog.Component.name]: Dialog.Component,
  },
  mixins: [PayMixins],
  created() {
    this.getData()
  },
  data() {
    return {
      keyword: '',
      list: [],
      // list: [{ "id": "220", "order_sn": "2021072237592165294205", "sly_goods_id": "11897", "goodsname": "\u4e5d\u9633(Joyoung)\u7535\u9676\u7089 \u7535\u78c1\u7089 \u5bb6\u7528\u706b\u9505\u5957\u88c5 \u4f4e\u8f90\u5c04\u5185\u5916\u53cc\u73af \u5927\u529f\u7387 \u7ea2\u5916\u5149\u6ce2\u52a0\u70edH22-X2 \u914d\u6c64\u9505+\u70e4\u76d8", "goodsimg": "http:\/\/img14.360buyimg.com\/n1\/jfs\/t1\/186192\/11\/14749\/183208\/60f4ddcbE3ee45c60\/6d98645f1dfec564.jpg", "buy_num": "1", "money_pay": "225.00", "status": "0", "status_pay": "1", "status_ship": "0", "status_refund": "0", "create_time": "2021-07-22 15:06:32", "status_str": "\u65b0\u8ba2\u5355", "status_pay_str": "\u5df2\u652f\u4ed8", "status_ship_str": "\u672a\u53d1\u8d27", "status_refund_str": "\u672a\u53d1\u8d77" }, { "id": "219", "order_sn": "2021072237581182455204", "sly_goods_id": "11899", "goodsname": "\u4e5d\u9633\uff08Joyoung\uff09\u7535\u538b\u529b\u9505 5L\u53cc\u80c6\u538b\u529b\u7172 \u81ea\u52a8\u65cb\u5408\u4e00\u952e\u5f00\u76d6 \u667a\u80fd\u8c03\u538b\u5168\u7a0b\u6cb8\u817eY-50Q801", "goodsimg": "http:\/\/img14.360buyimg.com\/n1\/jfs\/t1\/186267\/1\/11734\/418460\/60da912cE34f23845\/0d5d7d1a25559613.jpg", "buy_num": "1", "money_pay": "325.00", "status": "0", "status_pay": "0", "status_ship": "0", "status_refund": "0", "create_time": "2021-07-22 15:06:21", "status_str": "\u65b0\u8ba2\u5355", "status_pay_str": "\u672a\u652f\u4ed8", "status_ship_str": "\u672a\u53d1\u8d27", "status_refund_str": "\u672a\u53d1\u8d77" }, { "id": "214", "order_sn": "2021072235703029763452", "sly_goods_id": "11901", "goodsname": "\u4e5d\u9633\uff08Joyoung\uff09\u7834\u58c1\u673a\u5bb6\u7528\u591a\u529f\u80fd\u52a0\u70ed\u7834\u58c1\u6599\u7406\u673a\u8c46\u6d46\u673a\u679c\u6c41\u673a\u65e9\u9910\u673a\u7ede\u8089\u9985\u673a\u69a8\u6c41\u673a\u8f85\u98df\u673aL13-Y91S", "goodsimg": "http:\/\/img14.360buyimg.com\/n1\/jfs\/t1\/173419\/39\/19972\/147254\/60f7c091E6517a745\/37e0a7f52882c18b.jpg", "buy_num": "1", "money_pay": "275.00", "status": "0", "status_pay": "2", "status_ship": "0", "status_refund": "0", "create_time": "2021-07-22 14:35:03", "status_str": "\u65b0\u8ba2\u5355", "status_pay_str": "", "status_ship_str": "\u672a\u53d1\u8d27", "status_refund_str": "\u672a\u53d1\u8d77" }],
      status: [
        { title: '全部', status: 0 },
        { title: '待支付', status: 1 },
        { title: '已支付', status: 2 },
        { title: '已发货', status: 3 },
        { title: '已完成', status: 4 },
      ],
      active: 0,
      // 通过 actions 属性来定义菜单选项
      actions: [{ text: '申请退款' }],
      loading: false,
      finished: true,
      refreshing: false,
      tips_tk: false,
      status_str: '',
      tips_receive: false,
      page: 1,
      id: '',
      totalPages: 1,
      tips_refund: false,
      picture: '',
      desc: '',
      fileList: []
    }
  },
  methods: {
    getData() {
      if (this.refreshing) {
        this.list = [];
        this.refreshing = false;
      }
      let params = { p: this.page, status: this.active, kw: this.keyword }
      this.common.request({
        url: "MyOrder",
        methods: "post",
        params: params,
        callback: res => {
          this.loading = false
          console.log(res.data.data)
          if (res.data.errcode == 0) {
            this.list = res.data.data.data
            this.totalPages = res.data.data.totalPages
            if (this.page >= this.totalPages) {
              this.finished = true
            }
          } else {
            this.finished = true;
            this.loading = false;
          }
        }
      })
    },
    loadmore() {
      setTimeout(() => {
        if (this.refreshing) {
          this.list = [];
          this.refreshing = false;
        }
        if (this.loading) {
          this.page = this.page + 1
          let params = { p: this.page, status: this.active, kw: this.keyword }
          this.common.request({
            url: "MyOrder",
            methods: "post",
            params: params,
            callback: res => {
              if (res.data.errcode == 0) {
                this.loading = false;
                this.list = this.list.concat(res.data.data.data)
                this.totalPages = res.data.data.totalPages
                if (this.page >= this.totalPages) {
                  this.finished = true
                }
              } else {
                this.finished = true;
                this.loading = false;
              }
            }
          })

          if (this.page >= this.totalPages) {
            this.finished = true;
          }
        }
      }, 1000);
    },
    // status_pay == 1 && status_ship == 0 待发货
    // status == 0 && status_pay == 0 待支付
    // status_pay == 1 && status_ship == 1 已发货
    // status == 1 && status_pay == 1 && status_ship == 1 && status_fefund == 0 已完成
    // status == 1 && status_pay == 1 && status_ship == 1 && status_refund == 1 售后中
    // status == 1 && status_pay == 1 && status_ship == 1 && status_refund == 2 售后完成
    onRefresh() {
      // 清空列表数据
      this.finished = false;

      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.page = 1
      this.list = []
      this.keyword = ''
      this.loading = true;
      this.getData();
    },
    search() {
      this.finished = false
      this.page = 1
      this.list = []
      this.active = 0
      this.getData()
      this.keyword = ''
    },
    changeStatus(item, index) {
      this.finished = false
      this.active = item.status
      this.page = 1
      this.list = []
      this.getData()
    },
    afterRead(file) {
      var _this = this;
      let content = file.file
      // 此时可以自行将文件上传至服务器
      var form = new FormData();
      form.append("file", content);
      console.log(form.get("file"))
      // return
      // this.common.request({
      //   url: 'Upload',
      //   methods: 'post',
      //   params: data,
      //   callback: res => {
      //     console.log(res.data.data)
      //     if (res.data.errcode == 0) {
      //       this.picture = res.data.url
      //     }
      //   }
      // })
      this.$axios.post('http://city.shiminjia.com/activity/files/uploadOneOSS', form).then(res => {
        console.log(res.data.data)
        if (res.data.errcode == 0) {
          this.picture = res.data.url
        } else {
          this.$toast.fail(res.data.errmsg)
        }
      })

    },
    deleteFile(file, detail) {
      console.log("删除", detail.index);
      this.picture = ''
      // this.storeId.splice(detail.index, 1);
    },
    onOpen(item, index) {
      this.list[index].showPopover = true
      this.status_str = item.status_str
    },
    onSelect(action, index) {
      console.log(index)
      if (this.status_str == '已发货') {
        this.tips_tk = true
      }
    },
    openPay(item) {
      this.id = item.id
      this.show = true

    },
    openReceive(item) {
      this.id = item.id
      this.tips_receive = true
    },
    openRefund(item) {
      this.id = item.id
      this.tips_refund = true
    },
    delete_ship(item) {
      this.id = item.id
      let _this = this
      var params = { id: this.id }
      Dialog.confirm({
        title: '删除订单',
        message: '确认是否要删除订单',
      })
        .then(() => {
          this.common.request({
            url: 'DelOrder',
            methods: 'post',
            params: params,
            callback: res => {
              if (res.data.errcode == 0) {
                this.$toast.success(res.data.errmsg);
                setTimeout(function () {
                  _this.page = 1
                  _this.getData()
                }, 1000)
              } else {
                this.$toast.fail(res.data.errmsg);
              }
            }
          })
        })
        .catch(() => {
          // on cancel
        });
    },
    apply_refund(item) {
      this.id = item.id
      let _this = this
      var params = { id: this.id }
      Dialog.confirm({
        title: '退款',
        message: '确认是否要退款',
      })
        .then(() => {
          this.common.request({
            url: 'PayRefund',
            methods: 'post',
            params: params,
            callback: res => {
              if (res.data.errcode == 0) {
                this.$toast.success(res.data.errmsg);
                setTimeout(function () {
                  _this.page = 1
                  _this.getData()
                }, 1000)
              } else {
                this.$toast.fail(res.data.errmsg);
              }
            }
          })
        })
        .catch(() => {
          // on cancel
        });
    },
    hideRefund() {
      this.desc = ''
      this.picture = ''
      this.tips_refund = false
    },
    submit(item) {
      this.id = item.id
      this.Buy(this.id)
    },
    // 确认收货
    receive() {
      this.common.request({
        url: 'Receive',
        methods: 'post',
        params: { id: this.id },
        callback: res => {
          if (res.data.errcode == 0) {
            this.tips_receive = false
            this.page = 1
            this.active = 4
            this.getData()
          } else {
            this.$toast.fail(res.data.errmsg)
          }
        }
      })
    },
    // 发起售后
    refund() {
      let params = {
        id: this.id,
        desc: this.desc,
        picture: this.picture
      }
      this.common.request({
        url: 'Refund',
        methods: 'post',
        params: params,
        callback: res => {
          if (res.data.errcode == 0) {
            this.tips_refund = false
            this.desc = ''
            this.picture = ''
            this.page = 1
            this.getData()
          } else {
            this.$toast.fail(res.data.errmsg)
          }
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.page {
  background-color: #f4f4f4;
  min-height: 100vh;
  .navbar {
    padding: 0.1rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #fff;
    max-width: 750px;
    margin: 0 auto;
    .back {
      width: 0.09rem;
      height: 0.3rem;
      background: url("../assets/icon_back.png") no-repeat;
      background-size: 0.09rem auto;
      background-position: left center;
      padding-right: 0.26rem;
    }
    .search {
      width: 100%;
      height: 0.3rem;
      background-color: #ededed;
      border-radius: 0.15rem;
      background-image: url("../assets/icon_search.png");
      background-size: 0.17rem auto;
      background-position: 0.1rem center;
      background-repeat: no-repeat;
      input {
        width: 100%;
        height: 100%;
        padding-left: 0.35rem;
        font-size: 0.14rem;
        color: #666666;
      }
    }
    .searchBtn {
      width: 0.68rem;
      height: 0.3rem;
      background-color: linear-gradient(90deg, #daae4d, #e5be62);
      background-image: url("../assets/btn_bg.png");
      background-size: 100% 100%;
      border-radius: 0.15rem;
      text-align: center;
      line-height: 0.3rem;
      font-size: 0.14rem;
      color: #fff;
      margin-left: 0.14rem;
    }
  }
  .filter {
    border-top: 0.01rem solid #f4f4f4;
    border-bottom: 0.01rem solid #f4f4f4;
    height: 0.42rem;
    padding: 0 0.1rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #fff;
    max-width: 750px;
    margin: 0 auto;
    p {
      padding: 0 0.07rem;
      height: 100%;
      font-size: 0.14rem;
      color: #666;
      line-height: 0.42rem;
    }
    .active {
      color: #333;
      border-bottom: 0.02rem solid #ebd28e;
    }
  }
  .orderList {
    min-height: calc(100vh - 0.92rem);
    &-item {
      padding: 0.1rem;
      background-color: #fff;
      margin-bottom: 0.1rem;
      .head {
        display: flex;
        justify-content: space-between;
        align-items: center;
        span {
          font-size: 0.11rem;
          // color: #333;
          &:nth-child(2) {
            color: #c90827;
          }
        }

        .time {
          color: #333;
        }
      }
      .det {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-top: 0.1rem;
        .pic {
          width: 1.05rem;
          height: 1.05rem;
          background: #e5e5e5;
          border-radius: 0.075rem;
          img {
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
        }
        &-info {
          width: calc(100% - 1.2rem);
          h4 {
            font-size: 0.14rem;
            color: #333333;
            line-height: 0.21rem;
            display: -webkit-box;
            word-break: break-all;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2; // 需要显示的行数
            overflow: hidden;
            text-overflow: ellipsis;
          }
          & > p {
            font-size: 0.13rem;
            color: #666;
            padding: 0.05rem 0;
          }
          & > section {
            display: flex;
            justify-content: space-between;
            align-items: flex-end;
            span {
              &:first-child {
                font-size: 0.14rem;
                color: #666;
              }
              &:nth-child(2) {
                font-size: 0.12rem;
                color: #666;
              }
            }
            strong {
              font-size: 0.19rem;
              color: #c90827;
            }
          }
        }
      }
      .options {
        margin-top: 0.15rem;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .more {
          font-size: 0.12rem;
          color: #999;
        }
        .button {
          width: 0.72rem;
          height: 0.3rem;
          background: linear-gradient(90deg, #daae4d, #e5be62);
          border-radius: 0.15rem;
          background-image: url("../assets/btn_bg.png");
          background-size: 100% 100%;
          text-align: center;
          line-height: 0.3rem;
          font-size: 0.12rem;
          color: #fff;
        }
      }
    }
  }
  .dialog {
    width: 2.58rem;
    background-color: #ffffff;
    background-image: url("../assets/bg_dialog.jpg");
    background-repeat: no-repeat;
    background-size: 100% auto;
    border-radius: 0.05rem;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 99;
    &::before {
      content: "";
      display: block;
      width: 1.66rem;
      height: 0.99rem;
      background: url("../assets/img08.png") no-repeat;
      background-size: 1.66rem auto;
      position: absolute;
      left: 50%;
      top: -0.48rem;
      transform: translateX(-50%);
    }
    &-title {
      font-size: 0.15rem;
      color: #333;
      font-weight: bold;
      text-align: center;
      padding-top: 0.65rem;
    }
    p {
      font-size: 0.14rem;
      color: #333;
      text-align: center;
      padding: 0.15rem 0;
    }
    &-form {
      padding: 0.2rem 0.1rem;
    }
    &-button {
      width: 1.9rem;
      height: 0.39rem;
      background: linear-gradient(270deg, #ddb253, #f0cd7b);
      background-image: url("../assets/btn_bg.png");
      background-size: 100% 100%;
      border-radius: 0.19rem;
      text-align: center;
      line-height: 0.39rem;
      font-size: 0.14rem;
      color: #fff;
      margin: 0 auto 0.25rem;
    }
    &-btn {
      display: flex;
      align-items: center;
      justify-content: space-around;
      margin: 0 auto 0.25rem;
      .btn_cancel {
        width: 1.09rem;
        height: 0.37rem;
        border-radius: 0.19rem;
        color: #333;
        font-size: 0.14rem;
        text-align: center;
        line-height: 0.37rem;
        border: 0.01rem solid #999;
      }
      .btn_right {
        width: 1.11rem;
        height: 0.39rem;
        background-color: linear-gradient(270deg, #ddb253, #f0cd7b);
        background-image: url("../assets/btn_bg.png");
        background-size: 100% 100%;
        border-radius: 0.19rem;
        color: #fff;
        font-size: 0.14rem;
        text-align: center;
        line-height: 0.39rem;
      }
    }
  }
}
.button {
  width: 0.72rem;
  height: 0.3rem;
  background: linear-gradient(90deg, #daae4d, #e5be62);
  border-radius: 0.15rem;
  background-image: url("../assets/btn_bg.png");
  background-size: 100% 100%;
  text-align: center;
  line-height: 0.3rem;
  font-size: 0.12rem;
  color: #fff;
}
</style>